import { faChevronRight, faMoonStars } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../../shared/components/button/Button';
import useKeyboardAction from '../../shared/hooks/useKeyboardAction.ts';
import SleepTrackers from './SleepTracker';

function SleepCover(props) {
  const { closeTrackers } = props;
  const { t } = useTranslation();

  const [areaPicker, setAreaPicker] = useState(true);
  const [openSleep, setOpenSleep] = useState(false);

  const handleSleep = () => {
    const main = document.getElementById('snm-main');
    main?.classList.remove('slide-in');
    setTimeout(() => {
      setAreaPicker(false);
      setOpenSleep(true);
    }, 500);
  };

  useKeyboardAction(() => {
    closeTrackers();
  }, 'Escape');

  useEffect(() => {
    if (openSleep) {
      const sleep = document.getElementById('snm-sleep');
      setTimeout(() => {
        sleep?.classList.add('slide-in');
      }, 300);
    }
  }, [openSleep]);

  useEffect(() => {
    if (areaPicker) {
      const main = document.getElementById('snm-main');
      setTimeout(() => {
        main?.classList.add('slide-in');
      }, 300);
    }
  }, [areaPicker]);

  const handleBackToMain = () => {
    if (openSleep) {
      const sleep = document.getElementById('snm-sleep');
      sleep?.classList.remove('slide-in');
      setTimeout(() => {
        setOpenSleep(false);
        setAreaPicker(true);
      }, 500);
    }
  };

  return (
    <>
      {areaPicker && (
        <div id="snm-main" className="tracker-container">
          <div className="ind-tracker mood">
            <h2 className="title">{t('T134')}</h2>
            <button
              className="mood-area"
              onClick={handleSleep}
              type="button"
              aria-label={t('T345')}
            >
              <div>
                <FontAwesomeIcon icon={faMoonStars} className="mood-icon" /> {t('T345')}{' '}
              </div>
              <FontAwesomeIcon icon={faChevronRight} />
            </button>
          </div>
          <div className="buttons mood">
            <Button onClick={props.closeTrackers} variant="secondary" color="dark">
              {t('T015')}
            </Button>
          </div>
        </div>
      )}{' '}
      {openSleep && (
        <SleepTrackers handleBackToMain={handleBackToMain} closeTrackers={props.closeTrackers} />
      )}
    </>
  );
}
export default SleepCover;
